export default "/images/noImageAvailable.webp?1f3f829bc323390093a9f6e1b31651b4";